import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { translateDomainValidationErrorKey } from '../helpers/domain-url/translateDomainValidationErrorKey';

export function useDomainValidationMessage() {
  const { t } = useTranslation();
  return useCallback(
    (errorKey: string) => translateDomainValidationErrorKey(t, errorKey),
    [t]
  );
}
